import React, { createContext, useContext, useState } from "react";

const CurrentDeviceContext = createContext(null);

export function CurrentDeviceProvider({ children }) {
  const [device, setDevice] = useState(null);

  function setCurrentDevice(newItem) {
    setDevice((currentItem) => {
      currentItem = newItem;
      return newItem;
    });
  }

  return (
    <CurrentDeviceContext.Provider value={{ currentDevice: device, setCurrentDevice }}>
      {children}
    </CurrentDeviceContext.Provider>
  );
}

export function useCurrentDevice() {
  const context = useContext(CurrentDeviceContext);

  if (!context) {
    throw new Error(`"useCurrentDevice" must be called inside a "CurrentDeviceProvider"`);
  }

  return context;
}
